/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MonitoringItem } from '../../models/monitoring-item';
import { UpdateMonitoringDto } from '../../models/update-monitoring-dto';

export interface MonitoringControllerUpdate$Params {
  id: number;
      body: UpdateMonitoringDto
}

export function monitoringControllerUpdate(http: HttpClient, rootUrl: string, params: MonitoringControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItem;
}>> {
  const rb = new RequestBuilder(rootUrl, monitoringControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MonitoringItem;
      }>;
    })
  );
}

monitoringControllerUpdate.PATH = '/monitoring/{id}';
